import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { RtUIFormsModule } from '../../forms/forms.module';
import { ListSortableFormComponent } from './list-sortable-form.component';

@NgModule({
  exports: [ListSortableFormComponent],
  imports: [RtUIFormsModule, I18nModule, ListSortableFormComponent],
})
export class ListSortableFormModule {}
export { ListSortableFormComponent } from './list-sortable-form.component';
